import endpoint from "../../config/endpoints";

export const leaveYearJson = {
    showSaveNextBtn: true,
    formPath: "/leave-year-form",
    apiBaseURL: endpoint.leaveYear,
    changeExcel: endpoint.exportData,
    screenTitle: "Leave Year",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Leave Year",
    showExcelDownload: true,
    excelFileName: "Leave Year",
    formPathView: "/leave-year-view",
    tableColumnsToFilter: [
        {
            columnDisplayName: "Name",
            columnKeyName: "yearName",
            isChecked: true,
        },
        {
            columnDisplayName: "From Date",
            columnKeyName: "fromDate",
            isChecked: true,
        },
        {
            columnDisplayName: "To Date",
            columnKeyName: "toDate",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "yearName",
            inputType: "numberText",
            isMandatory: true,
            uniqueValidation: true,
        },
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
        },
    ],
};
